import React, { useEffect, useState, useMemo } from 'react'
import GridSearchTemplate from '../../../pages/GridSearchTemplate'
import { DatePicker } from '../../shared/DatePicker'
import { useTextResources } from '../../../language'
import { Form } from 'semantic-ui-react'
import HotelsDropDown from '../../shared/HotelsDropDown'
import { GetRoomsForecastData } from '../../../api/services/pms';
import Moment from 'moment'
import { extendMoment } from 'moment-range';
const moment = extendMoment(Moment);
import PropTypes from 'prop-types'
import { GetHotels } from '../../../api/services/organization'
import { onError } from '../../shared/messages'
import _ from 'lodash'
import { dateFormat, dateFormatShort } from '../../shared/constants'
import { createExcelHeader } from '../../GridPanel/utility'

const RoomsForecastReport = ({ HotelID }) => {
    const text = useTextResources()
    const [searchState, setSearchState] = useState({})
    const [data, setData] = useState([])
    const [hotels, setHotels] = useState([])
    const days = 10

    useEffect(() => {
        (async () => {
            try {
                const hotels = await GetHotels()
                setHotels(hotels)
            } catch (error) {
                onError(error)
            }
        })()
    }, [HotelID])

    const onSearchChange = (search) => {
        if (!search.StartDate) {
            search.StartDate = moment().startOf("day").toDate();
        }
        setSearchState(search)
    }

    const onSearchComplete = (data, searchState) => {
        setSearchState(searchState)
        const rows = ["TotalRooms", "OutOfOrder", "AvailableForSale", "StaysOver", "IndividualArrivals", "GroupArrivals", "FamilyAndFriendsArrivals", "IndividualDepartures", "GroupDepartures", "FamilyAndFriendsDepartures", "Occupied", "ExpectedVacancy", "Occupancy", "DayUse"]
        const range = moment.range(moment(searchState.StartDate), moment(searchState.StartDate).add(days, "days"));
        let newData = rows.map(row => {
            let newRow = {
                "Description": text(row),
                "Id": row
            }
            for (let date of range.by("day")) {
                const dateStr = date.format(dateFormat)

                var currentAvailable = data.availability.filter(obj => moment(obj.Date).isSame(date.clone(), "day"));
                let rangeReservations = data.reservations.filter(obj => date.isBetween(moment(obj.CheckInDate).startOf("day"), moment(obj.CheckOutDate).startOf("day"), undefined, '[)'))
                let stayOverReservations = rangeReservations.filter(obj => !(moment(obj.CheckOutDate).isSame(date.clone(), "day") || moment(obj.CheckInDate).isSame(date.clone(), "day")))
                var rangeOfOccupiedReservations = data.reservations.filter(obj => moment(obj.CheckInDate).isSameOrBefore(date, 'day') && moment(obj.CheckOutDate).isAfter(date, 'day'))
                var dayUseOccupiedReservations = data.reservations.filter(obj => moment(obj.CheckInDate).isSame(date.clone(), "day") && moment(obj.CheckOutDate).isSame(date.clone(), "day"))
                var currentArrivalReservation = data.reservations.filter(obj => moment(obj.CheckInDate).isSame(date.clone(), "day"));
                var currentDepartureReservation = data.reservations.filter(obj => moment(obj.CheckOutDate).isSame(date.clone(), "day"));

                const groupArrivals = currentArrivalReservation.filter(obj => obj.ReservationGroupID)
                const partyArrivals = currentArrivalReservation.filter(obj => obj.ReservationPartyID)
                const individualArrivals = currentArrivalReservation.filter(obj => !obj.ReservationGroupID && !obj.ReservationPartyID)

                const groupDepartures = currentDepartureReservation.filter(obj => obj.ReservationGroupID)
                const partyDepartures = currentDepartureReservation.filter(obj => obj.ReservationPartyID)
                const individualDepartures = currentDepartureReservation.filter(obj => !obj.ReservationGroupID && !obj.ReservationPartyID)

                switch (row) {
                    case 'TotalRooms':
                        newRow[dateStr] = data.rooms.length
                        newRow["ParentId"] = null
                        break;
                    case 'OutOfOrder':
                        if (data.plannedMaintenances) {
                            newRow[dateStr] = data.plannedMaintenances.filter(
                              (obj) =>
                                date.isBetween(
                                  moment(obj.StartDate).startOf('day'),
                                  moment(obj.EndDate).startOf('day'),
                                  undefined,
                                  '[)' //EndDate is exclusive
                                ) && obj.IsActive
                            ).length;
                        } else {
                            newRow[dateStr] = 0
                        }
                        newRow["ParentId"] = null
                        break;
                    case 'AvailableForSale':
                        newRow[dateStr] = currentAvailable.reduce((initialValue, item) => initialValue + item.Available, 0)
                        newRow["ParentId"] = null
                        break;
                    case 'StaysOver':
                        newRow[dateStr] = stayOverReservations.length;
                        newRow["ParentId"] = null
                        break;
                    case 'GroupArrivals':
                        newRow[dateStr] = _.sumBy(groupArrivals, "Quantity")
                        newRow["ParentId"] = null
                        break;
                    case 'FamilyAndFriendsArrivals':
                        newRow[dateStr] = partyArrivals.length
                        newRow["ParentId"] = null
                        break;
                    case 'IndividualArrivals':
                        newRow[dateStr] = individualArrivals.length
                        newRow["ParentId"] = null
                        break;
                    case 'GroupDepartures':
                        newRow[dateStr] = _.sumBy(groupDepartures, "Quantity")
                        newRow["ParentId"] = null
                        break;
                    case 'FamilyAndFriendsDepartures':
                        newRow[dateStr] = partyDepartures.length
                        newRow["ParentId"] = null
                        break;
                    case 'IndividualDepartures':
                        newRow[dateStr] = individualDepartures.length
                        newRow["ParentId"] = null
                        break;
                    case 'Occupied':
                        newRow[dateStr] = rangeOfOccupiedReservations.length
                        newRow["ParentId"] = null
                        break;
                    case 'ExpectedVacancy':
                        newRow[dateStr] = currentAvailable.reduce((initialValue, item) => initialValue + item.Available, 0)
                        newRow["ParentId"] = null
                        break;
                    case 'Occupancy':
                        if (currentAvailable.length == 0) {
                            newRow[dateStr] = "0%"
                        } else {
                            let totalAvailable = currentAvailable.reduce((initialValue, item) => initialValue + item.Available, 0);
                            let totalGrossInventory = currentAvailable.reduce((initialValue, item) => initialValue + item.GrossInventory, 0);
                            newRow[dateStr] = ((1 - (totalAvailable / totalGrossInventory).toFixed(2)) * 100).toFixed(0) + "%"
                        }
                        newRow["ParentId"] = null
                        break;
                    case 'DayUse':
                        if (dayUseOccupiedReservations) {
                            newRow[dateStr] = dayUseOccupiedReservations.length
                        } else {
                            newRow[dateStr] = 0
                        }
                        break;
                }
            }
            return newRow

        })

        setData(newData)
    }

    const formatter = ({ value }) => {
        return <div style={{ fontSize: '1.2rem' }}>{value}</div>
    }
    const columns = useMemo(() => {
        const range = moment.range(moment(searchState.StartDate), moment(searchState.StartDate).add(days, "days"));
        const dateColumns = Array.from(range.by("day")).map(day => {
            return {
                name: day.format(dateFormat),
                title: day.format(dateFormatShort),
                formatter
            }
        })
        return [
            { name: 'Description', title: 'Description', formatter },
            ...dateColumns
        ]
    }, [searchState.StartDate])


    const columnExtensions = useMemo(() => {
        const range = moment.range(moment(searchState.StartDate), moment(searchState.StartDate).add(days, "days"));
        const dateColumnExtensions = Array.from(range.by("day")).map(day => {
            return {
                columnName: day.format(dateFormat),
                width: 135
            }
        })
        return [
            ...dateColumnExtensions
        ]
    }, [searchState.StartDate])

    const getExcelHeaderTitle = () => {
        const hotel = hotels.find(x => x.Id === HotelID)
        return `Rooms Forecast Report ${hotel && hotel.Name}, ${moment(searchState.StartDate).format(dateFormat)} - ${moment(searchState.StartDate).add(days, "days").format(dateFormat)}`;
    }


    const gridOptions = useMemo(() => {
        return {
            search: {
                title: text("RoomsForecastReport"),
                fields: [
                    <Form.Field control={HotelsDropDown} clearable width="4" label={text("Hotel")} key="HotelID" />,
                    <DatePicker
                        type="basic"
                        label={text("StartDate")}
                        name="StartDate"
                        key="StartDate"
                    />
                ],
                initial: {
                    "StartDate": moment().startOf("day").toDate(),
                    "HotelID": HotelID
                },
                api: GetRoomsForecastData,
                spec: {
                    EndDate: moment(searchState.StartDate).add(days, "days").toISOString(),
                    HotelIDs: HotelID
                },
                groupSize: 6
            },
            grid: {
                columns: columns,
                summary: true,
                export: true,
                pdf: true,
                excel: {
                    customizeHeader: createExcelHeader(getExcelHeaderTitle()),
                },
                columnExtensions: columnExtensions
            }
        }
    }, [data])

    return (<GridSearchTemplate options={gridOptions} onSearchComplete={onSearchComplete} onSearchChange={onSearchChange} data={data} />)
}
RoomsForecastReport.propTypes = {
    HotelID: PropTypes.any
}
export default RoomsForecastReport
